import { post, get } from "../http";

//* *****首页*********///
// 友情链接
export function frontPage_queryLinks(data) {
  return get("/web/frontPage/queryLinks", data);
}
// 领导设置、标准公开征求意见接口
export function get_queryBannerLeaderOpinion(data) {
  return get("/web/frontPage/queryBannerLeaderOpinion", data);
}

//   新闻动态、会议动态、文档中心、产业服务接口
export function get_queryNewConfereDocTest(data) {
  return get("/web/frontPage/queryNewConfereDocTest", data);
}

//* *****menu*********///
// 工作动态
export function post_workdynamics(data) {
  return post("/web/work/dynamics", data);
}
// 工作动态-详情
export function get_dynamicsDetail(data) {
  return get("/web/work/dynamicsDetail/" + `${data.id}/${data.type}`);
}

// 标准查询
export function post_standardQuery(data) {
  return post("/web/work/standardQuery", data);
}

// 测试测评
export function post_testEvaluationList(data) {
  return post("/web/work/testEvaluationList", data);
}
// /api/v1/web/work/detail/{id}
//产业服务详情
export function get_workdetail(data) {
  return get("/web/work/detail/" + `${data.id}`);
}
// 文档中心
export function post_documentCenterList(data) {
  return post("/web/work/documentCenterList", data);
}

// 领导设置
export function get_leadershipSettings(data) {
  return get("/web/work/leadershipSettings/");
}

//全局搜索
export function post_searchGlobalList(data) {
  return post("/web/work/searchGlobalList", data);
}

/****关于我们**** */
//关于我们，机构设置
export function get_institutionalSettings(data) {
  return get("/web/work/institutionalSettings", data);
}

// 获取技术委员会列表
export function post_selectCommitteePositionList(data) {
  return post("/web/frontPage/selectCommitteePositionList", data);
}

// 获取工作组列表
export function post_selectWorkGroupList(data) {
  return post("/web/frontPage/selectWorkGroupList", data);
}

// 获取全局参数信息
export function get_frontPageinfo(data) {
  return get("/web/frontPage/info", data);
}
//GET
// ​/api​/v1​/web​/frontPage​/selectTcCarouselList
// 产品服务配置列表查询
export function get_frontPageselectTcCarouselList(data) {
  return get("/web/frontPage/selectTcCarouselList", data);
}

// 统计数据
export function gettotalData(data) {
  return get("/web/frontPage/selectFontPageStatisticsl", data);
}


// WEBPACK FOOTER //
// ./src/api/modules/home.js